module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_1.a8d51aa0.svg";